var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('Toolbar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"height":"100vh"}},[_c('iframe',{attrs:{"src":"https://api.precompro.com/docs/politicaTratamientoDatos.pdf","width":"100%","height":"100%"}})])])
}]

export { render, staticRenderFns }